/**
 * Format number as currency (GBP)
 */
export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

/**
 * Format large numbers with K/M suffix
 */
export const formatCompactCurrency = (value: number): string => {
  if (value >= 1000000) {
    return `£${(value / 1000000).toFixed(2)}M`;
  } else if (value >= 1000) {
    return `£${(value / 1000).toFixed(0)}K`;
  }
  return formatCurrency(value);
};

/**
 * Format signed currency variance: +£120K or -£70K
 */
export const formatVariance = (value: number): string => {
  const sign = value >= 0 ? '+' : '-';
  const abs = Math.abs(value);
  if (abs >= 1000000) {
    return `${sign}£${(abs / 1000000).toFixed(2)}M`;
  } else if (abs >= 1000) {
    return `${sign}£${(abs / 1000).toFixed(0)}K`;
  }
  return `${sign}£${abs.toFixed(0)}`;
};

/**
 * Format percentage
 */
export const formatPercentage = (value: number | undefined | null): string => {
  if (value === undefined || value === null || isNaN(value)) {
    return '0.0%';
  }
  return `${value.toFixed(1)}%`;
};

/**
 * Get status color class
 */
export const getStatusColor = (status: string): string => {
  const statusMap: Record<string, string> = {
    ON_TRACK: 'text-success',
    AHEAD: 'text-success',
    NEEDS_ATTENTION: 'text-warning',
    OFF_TRACK: 'text-danger',
  };
  return statusMap[status] || 'text-text-secondary';
};

/**
 * Get confidence color class
 */
export const getConfidenceColor = (confidence: string): string => {
  const confidenceMap: Record<string, string> = {
    HIGH: 'text-success',
    MEDIUM: 'text-warning',
    LOW: 'text-danger',
  };
  return confidenceMap[confidence] || 'text-text-secondary';
};
